import React from "react";
import { useSearchParams } from "react-router-dom";
import PasteAnnouncement from "../../components/announce/PasteAnnouncement";

/** /announce?draft=<id>: the web editor linked from the WhatsApp "Edit" reply. */
const AnnouncePage: React.FC = () => {
  const [params] = useSearchParams();
  return (
    <div className="p-4 pb-24">
      <PasteAnnouncement draftId={params.get("draft") || undefined} />
    </div>
  );
};
export default AnnouncePage;
